/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { filter, take } from 'rxjs/operators';

import { AppState, AppStateUser } from '../app-state.service';
import { firebaseTimeDiff } from '@touchplan/firebase-common';
import { ILoggerService } from '@touchplan/logging';
import { LoggerServiceFactory } from 'src/app/common/logging/LoggerServiceFactory';
import { ProjectFirebaseCloudFunctionsService } from '../firebase-cloud-functions/project-cloud-functions.service';

@Injectable({ providedIn: 'root' })
export class RunOnUserLoadedHook {
	private logger: ILoggerService;
	constructor(
		private appState: AppState,
		private projectFBCloudFunctionsService: ProjectFirebaseCloudFunctionsService
	) {
		this.logger = LoggerServiceFactory.create('RunOnUserLoadedHook');
	}

	public start() {
		//only once
		this.appState.user
			.pipe(
				filter((user) => user !== null && user !== undefined),
				take(1)
			)
			.subscribe((user) => {
				this.logger.log('first user', user);
				this.checkIndices(user);
			});
	}

	private checkIndices(user: AppStateUser) {
		// TODO: Implement a solution using observables
		firebaseTimeDiff(user.lastVerifiedIndices, 'days')
			.then((time) => {
				if (time > 0) {
					return lastValueFrom(
						this.projectFBCloudFunctionsService.validateAndRepairMembership(user.$id)
					).then((response) => {
						if (response.userWasRepaired) {
							window.location.reload();
						}
					});
				} else {
					this.logger.log('index verification ran earlier, skipping...');
				}
			})
			.catch((e) => {
				//nothing the user can really do about this, _ideally_ would report to some sort of remote logging service
				this.logger.error(e);
			});
	}
}
